import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Icon } from "../../components/icons";
import { Widget } from "../../components/widget";
import { colours } from "../../styles/colours";

const StyledWidget = styled(Widget)`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-grow: 1;
  align-items: center;
`;

const MainIcon = styled(Icon)`
  height: 8em;
  width: 8em;
`;

export type ResultPageProps = {
  transactionHash: string;
  purchaseID?: string;
  error?: Error;
};

export const ResultPage: FC<ResultPageProps> = (props) => {
  const { t } = useTranslation("common");
  if (props.error)
    return (
      <StyledWidget>
        <h2>{t("error-has-occured")}</h2>
        <MainIcon type="close" colour1={colours.red} />
        <div>
          <div>
            {t("transaction-#")}: [{props.transactionHash}]
          </div>
          <div>{props.error.message}</div>
        </div>
      </StyledWidget>
    );

  return (
    <StyledWidget>
      <h2>{t("purchase-successful", { ns: "billing" })}</h2>
      <MainIcon type="veryGoodCheck" />
      <div>
        <div>
          {t("transaction-#")}: [{props.transactionHash}]
        </div>
        <div>
          {t("purchase-id", { ns: "billing" })}: [{props.purchaseID}]
        </div>
      </div>
    </StyledWidget>
  );
};
